import React, { useState } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";

const Navbar = () => {
  const [nav, setNav] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  return (
    <div className="flex justify-between items-center h-24  mx-auto px-4 bg-gradient-to-r from-green-100 to-blue-100">
      <h1 className="text-6xl  font-bold text-black text-center pb-5 pl-3 ">
        <span className="text-4xl  font-bold text-center pb-5 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent ">
          Cdemy
        </span>
      </h1>

      <ul className="hidden md:flex">
        <li className="p-7   text-xl text-black-700  hover:underline hover:underline-offset-8 cursor-pointer transition-colors duration-300 active:text-green-700 active:underline active:underline-offset-8">
          Home
        </li>
        <li className="p-7 text-xl text-black-700  hover:underline hover:underline-offset-8 cursor-pointer transition-colors duration-300 active:text-green-700 active:underline active:underline-offset-8">
          Services
        </li>
        <li className="p-7 text-xl text-black-700  hover:underline hover:underline-offset-8 cursor-pointer transition-colors duration-300 active:text-green-700 active:underline active:underline-offset-8">
          Work
        </li>
        <li className="p-7 text-xl text-black-700  hover:underline hover:underline-offset-8 cursor-pointer transition-colors duration-300 active:text-green-700 active:underline active:underline-offset-8">
          About
        </li>
        <li className="p-5 pl-40">
          <button className="middle none center rounded-lg  py-2 px-4 bg-gradient-to-r from-green-400 to-blue-500  text-base uppercase text-white shadow-md bg-[#005959] hover:shadow-lg hover:shadow-green-600/40 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none">
            Contact
          </button>
        </li>
      </ul>
      <div onClick={handleNav} className="block md:hidden">
        {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
      </div>
      <ul
        className={
          nav
            ? "fixed left-0 top-0 w-[60%] h-full border-r border-r-gray-900 bg-[#000300] ease-in-out duration-500"
            : "ease-in-out duration-500 fixed left-[-100%]"
        }
      >
        <h1 className="text-6xl  font-bold text-black text-left pb-5 pl-4">
          <span className="text-4xl  font-bold text-left pb-5 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent ">
            Cdemy
          </span>
        </h1>
        <li className="p-4 border-b border-gray-600">Home</li>
        <li className="p-4 border-b border-gray-600">Company</li>
        <li className="p-4 border-b border-gray-600">Resources</li>
        <li className="p-4 border-b border-gray-600">About</li>
        <li className="p-4">Contact</li>
      </ul>
    </div>
  );
};

export default Navbar;
